import { Box, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { getTransportLabelSx } from './transportTypographySx';

AppointmentDescription.propTypes = {
  value: PropTypes.string,
  setFields: PropTypes.func,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  detailsMode: PropTypes.bool,
};

export default function AppointmentDescription({ value, setFields, disabled = false, multiline = true, detailsMode = false }) {
  return (
    <Box sx={{ pl: 2 }}>
      <Typography color="text.secondary" sx={{ ...getTransportLabelSx(detailsMode), mb: 1 }}>
        Appointment Description:
      </Typography>
      <TextField
        label=""
        multiline={multiline}
        minRows={3}
        fullWidth
        variant="outlined"
        value={value}
        onChange={setFields}
        sx={{
          '& .MuiOutlinedInput-root fieldset': { borderColor: '#E5E1E1' },
        }}
        disabled={disabled}
      />
    </Box>
  );
}
